import React from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import { useTranslation } from 'react-i18next';
import GuestPassLogTable from './GuestPassLogTable';

const GuestPassLog: React.FC = () => {
    const { t } = useTranslation();
    return (
        <OpPage title={t('guestPassLog.title')}>
            <GuestPassLogTable />
        </OpPage>
    );
}

export default GuestPassLog;
